import NotFound from './NotFound';
import query from './NotFoundQuery.graphql';

NotFound.query = query;

export default NotFound;
